// src/hooks/useUserProfile.js
import { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { fetchUserByUsername, fetchUserById } from '../store/slices/user.slice'
import { fetchReviews } from '../store/slices/review.slice'
import { fetchCommentsByUserId } from '../store/slices/comment.slice'


export function useUserProfile(usernameParam) {
  const dispatch = useDispatch()
  const params = useParams()

  const [userId, setUserId] = useState(null)
  const [isEditing, setIsEditing] = useState(false)
  const [activeTab, setActiveTab] = useState('watchOrReadList')

  const didLoad = useRef(false)

  const { users, isLoading, error, loggedInUser } = useSelector(
    (state) => state.userModule
  )
  const comments = useSelector((state) => state.commentModule.comments || [])
  const reviews = useSelector((state) => state.reviewModule.reviews || [])

  const paramUserId = params.userId
  const paramUsername = params.username || usernameParam

  useEffect(() => {
    if (didLoad.current) return
    didLoad.current = true

    if (paramUsername && !paramUserId) {
      dispatch(fetchUserByUsername(paramUsername))
        .unwrap()
        .then((userFromServer) => {
          if (!userFromServer?._id) throw new Error('Missing user ID from server')
          const uid = userFromServer._id
          setUserId(uid)
          loadUserData(uid)
        })
        .catch((err) => {
          console.error('❌ שגיאה בשליפת משתמש לפי username:', err)
        })
    } else if (paramUserId) {
      setUserId(paramUserId)
      loadUserData(paramUserId)
    }
  }, [paramUsername, paramUserId, dispatch])

  function loadUserData(uid) {
    if (!uid) return
    dispatch(fetchReviews({ userId: uid }))
    dispatch(fetchCommentsByUserId({ userId: uid }))
    dispatch(fetchUserById(uid))

  }

  const user = Array.isArray(users)
    ? users.find((u) => u?._id === userId)
    : null

  const userReviews = reviews.filter((review) => review.userId === userId)
  const recommendationsCount = userReviews.filter((r) => r.recommended).length
  const disappointmentsCount = userReviews.filter((r) => r.recommended === false).length

  return {
    user,
    userId,
    reviews,
    comments,
    isLoading,
    error,
    recommendationsCount,
    disappointmentsCount,
    loggedInUser,
    isEditing,
    setIsEditing,
    activeTab,
    setActiveTab,
  }
}
